import React, { createContext, useContext, useState, useEffect } from 'react';

const LanguageContext = createContext();

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState(() => {
    // Always default to Turkish on first visit
    const savedLanguage = localStorage.getItem('language');
    return savedLanguage || 'tr';
  });

  useEffect(() => {
    // Save to localStorage
    localStorage.setItem('language', language);
    // Set HTML lang attribute
    document.documentElement.lang = language;
    // Set direction for Arabic (RTL), otherwise LTR
    document.documentElement.dir = language === 'ar' ? 'rtl' : 'ltr';
  }, [language]);

  const changeLanguage = (lang) => {
    setLanguage(lang);
  };

  return (
    <LanguageContext.Provider value={{ language, changeLanguage }}>
      {children}
    </LanguageContext.Provider>
  );
};
